<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { AppRoute } from '@ts-routes/enums'

import { useSubscriptionStore } from '@stores/subscription'

import { useFailedPaymentRetry } from '@hooks/subscription/failed-payment-retry.hook'

import amplitudeConf from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import bg from '@images/payment-retry/bg.png'

defineOptions({
  name: 'ModalRetryPayment',
})

const AppModal = defineAsyncComponent(() => import('@UI/Modals/AppModal').then((module) => module.AppModal))

const subscriptionStore = useSubscriptionStore()

const {
  name,
  btnText,
  setSubmit,
} = useFailedPaymentRetry()

onMounted(() => {
  trackEvent(amplitudeConf.events.popupView, {
    name,
    popup_name: name,
    popup_title: subscriptionStore.getPaymentRetryErrorTitle,
  })
})

const setClose = (): void => {
  trackEvent(amplitudeConf.events.clickCloseButton, {
    button_name: 'close_retry_payment_modal',
  })
  subscriptionStore.setRetryPaymentModal(false)
}

const setCheckPaymentMethod = (): void => {
  trackEvent(amplitudeConf.events.clickSubmitButton, {
    name,
    button_name: 'check_payment_method',
    button_text: 'Check payment method',
  })

  subscriptionStore.setRetryPaymentModal(false)

  const url = AppRoute.PaymentsMethods
  if (url) navigateTo(url)
}

</script>

<template>
  <AppModal
    :loading="subscriptionStore.isLoading"
    @close="setClose"
  >
    <template #topSlot>
      <div class="retry-payment__hero">
        <img
          :src="bg"
          alt="error illustration"
        >
      </div>
    </template>
    <template #contentSlot>
      <div class="retry-payment__content">
        <h5 class="retry-payment__title-xl btly-text-title-xl">
          {{ subscriptionStore.getPaymentRetryErrorTitle }}
        </h5>
        <div class="retry-payment__body-l btly-text-body-l">
          {{ subscriptionStore.getPaymentRetryErrorText }}
        </div>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        fill
        :text="btnText"
        :disabled="subscriptionStore.isLoading"
        @click="setSubmit"
      />
      <Button
        view="secondary"
        fill
        text="Check payment method"
        :disabled="subscriptionStore.isLoading"
        @click="setCheckPaymentMethod"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="@scss/components/Modals/RetryPayment/ModalRetryPayment.scss" />
